﻿import { evenRound } from "./Calculation";

export function roundCents(price: number) {
    return evenRound(price, 2);
}

export function calculateTotal(cost: number, qty: number) {
    return roundCents(cost * qty);
}

export function calculateMarkup(cost: number, markup: number, round = true) {
    const amount = cost * markup / 100;

    if (round) {
        return roundCents(amount);
    }
    else {
        return amount;
    }
}

export function applyMarkups(cost: number, ...markups: number[]) {
    let total = cost;
    markups.forEach(markup => total = roundCents(total + calculateMarkup(cost, markup)));

    return total;
}

export function addPrices(...prices: number[]) {
    return prices.reduce((total, price) => roundCents(total + price), 0);
}

export interface Pricing {
    cost: number;
    costExclVat: number;
    costVat: number;
    logisticsAmount: number;
    packerAmount: number;
    costWithPackerAndLogistics: number;
    hubMarkupAmount: number;
    clubMarkupAmount: number;
    priceExclVat: number;
    expectedPrice: number;
}

export function calculatePricing(cost: number, hubMarkup: number, markup: number, logisticsMarkup: number, packerMarkup: number, vatRate: number, vatZeroRate: boolean, supplierVatRegistered: boolean, clubVatRegistered: boolean, isHost = false) {
    let inputVatRate = vatRate;
    let outputVatRate = vatRate;
    if (vatZeroRate || !supplierVatRegistered) {
        inputVatRate = 0;
    }
    if (vatZeroRate || !clubVatRegistered) {
        outputVatRate = 0;
    }

    const costExclVat = cost / (1 + inputVatRate / 100);
    const costVat = cost - costExclVat;

    if (isHost) {
        hubMarkup = 0;
        markup = 0;
        logisticsMarkup = 0;
    }

    const logisticsAmount = calculateMarkup(cost, logisticsMarkup, false);
    const packerAmount = calculateMarkup(cost, packerMarkup, false);
    const costWithPackerAndLogistics = cost + packerAmount + logisticsAmount;

    const hubMarkupAmount = calculateMarkup(costWithPackerAndLogistics, hubMarkup);
    const clubMarkupAmount = calculateMarkup(costWithPackerAndLogistics, markup);

    const priceExclVat = costExclVat + logisticsAmount + packerAmount + hubMarkupAmount + clubMarkupAmount;

    const vat = calculateMarkup(priceExclVat, outputVatRate, true);

    const expectedPrice = roundCents(clubVatRegistered ? priceExclVat + vat : costWithPackerAndLogistics + hubMarkupAmount + clubMarkupAmount);

    const pricing: Pricing = {
        cost: cost, //cost of goods
        costExclVat: costExclVat, //ex vat cost of goods
        costVat: costVat, //vat portion of cost of goods
        logisticsAmount: logisticsAmount, //logistics markup on cost
        packerAmount: packerAmount, //packer amount on cost
        costWithPackerAndLogistics: costWithPackerAndLogistics, //cost + logistics
        hubMarkupAmount: hubMarkupAmount, //hub markup on cost + logistics
        clubMarkupAmount: clubMarkupAmount, //club markup on cost + logistics
        priceExclVat: priceExclVat, //calculated price to member ex vat
        expectedPrice: expectedPrice //calculated price to member with vat
    }

    return pricing;
}